import { useEffect } from "react";

const SITE = "https://www.aspenexecutivelimos.com";

export const BUSINESS_LD = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE}/#business`,
  name: "Aspen Executive Limo",
  description:
    "Luxury private chauffeured transportation and airport car service in Aspen, Colorado. Executive SUV transfers for the Roaring Fork Valley, Vail, and Denver.",
  url: SITE,
  telephone: "+1-970-315-6500",
  priceRange: "$$$",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Aspen",
    addressRegion: "CO",
    addressCountry: "US",
  },
  areaServed: [
    { "@type": "City", name: "Aspen, CO" },
    { "@type": "City", name: "Snowmass, CO" },
    { "@type": "City", name: "Basalt, CO" },
    { "@type": "City", name: "Carbondale, CO" },
    { "@type": "City", name: "Glenwood Springs, CO" },
    { "@type": "City", name: "Vail, CO" },
    { "@type": "City", name: "Denver, CO" },
  ],
};

export function useSEO({ title, description, keywords, canonical, image, jsonLd }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const created = [];
    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      const preexisting = !!el;
      const prev = el ? el.getAttribute("content") : null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
      created.push({ el, preexisting, prev });
    };

    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    let canonEl = null;
    let canonPrev = null;
    let canonPreexisting = false;
    if (canonical) {
      canonEl = document.head.querySelector('link[rel="canonical"]');
      canonPreexisting = !!canonEl;
      canonPrev = canonEl ? canonEl.getAttribute("href") : null;
      if (!canonEl) {
        canonEl = document.createElement("link");
        canonEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonEl);
      }
      canonEl.setAttribute("href", canonical);
    }

    let ldScript = null;
    if (jsonLd) {
      ldScript = document.createElement("script");
      ldScript.type = "application/ld+json";
      ldScript.text = JSON.stringify(jsonLd);
      document.head.appendChild(ldScript);
    }

    return () => {
      document.title = prevTitle;
      created.forEach(({ el, preexisting, prev }) => {
        if (preexisting) el.setAttribute("content", prev ?? "");
        else el.remove();
      });
      if (canonEl) {
        if (canonPreexisting) canonEl.setAttribute("href", canonPrev ?? "");
        else canonEl.remove();
      }
      if (ldScript) ldScript.remove();
    };
  }, [title, description, keywords, canonical, image, jsonLd]);
}
